import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getCurrentMemberSubscription, getPrimaryMemberCard, memberHasSubscriptions } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Suspense } from 'react';
import { useMemberContext } from '../../../context/member/hooks/use-member-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { MemberBarcode } from '../barcode/member-barcode';
import { MemberCardLogo } from './subcomponents/logo';
import { MemberCardMember } from './subcomponents/member';
import { MemberCardMembershipDetails } from './subcomponents/membership-details';
import { MemberCardSkeleton } from './subcomponents/skeleton';
import { defaultMemberCardProps, memberCardPropsValidator } from './types/props';
const b = bemClassBuilder('v-member-card');
export const MemberCard = observer(props => {
    var _a;
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { displayText, config, cdnOptions } = props;
    const { member } = useMemberContext();
    const loadingIndicator = enableSkeletonLoadingIndicators ? _jsx(MemberCardSkeleton, {}) : null;
    if (!member)
        return loadingIndicator;
    const primaryCard = getPrimaryMemberCard();
    if (!primaryCard)
        return null;
    const hasSubscription = memberHasSubscriptions();
    const memberSubscriptionId = (_a = getCurrentMemberSubscription()) === null || _a === void 0 ? void 0 : _a.subscriptionId;
    return (_jsx(Suspense, Object.assign({ fallback: loadingIndicator }, { children: _jsxs("div", Object.assign({ className: b.block({ subscription: hasSubscription }) }, { children: [_jsxs("div", Object.assign({ className: b.element('upper-section', {
                        hasSubscription: hasSubscription,
                        subscription: memberSubscriptionId === null || memberSubscriptionId === void 0 ? void 0 : memberSubscriptionId.toString()
                    }) }, { children: [_jsx(MemberCardLogo, { showAsSubscription: hasSubscription, clubId: member.clubMembership.clubId, cdnOptions: cdnOptions }), _jsx(MemberCardMember, { member: member, displayText: displayText, showPhoto: config.showMemberPhoto })] })), _jsxs("div", Object.assign({ className: b.element('lower-section') }, { children: [_jsx(MemberBarcode, { config: { type: config.barcodeType } }), _jsx(MemberCardMembershipDetails, { displayText: displayText })] }))] })) })));
});
MemberCard.displayName = 'MemberCard';
/**
 * The **Member Card** component renders a digital membership card for the currently logged-in Loyalty member's primary card.
 *
 * If the currently logged-in member does not have a primary card, the **Member Card** component will not render.
 */
export const MemberCardComponent = withComponentWrapper(MemberCard, defaultMemberCardProps, memberCardPropsValidator);
